export default [
  // *===============================================---*
  // *--------- Menu ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/menus/list',
    name: 'pages-menus-list',
    component: () => import('@/views/pages/menu/MenuList.vue'),
    meta: {
      resource: 'menu',
      action: 'read',
    },
  },
  {
    path: '/menus/add',
    name: 'pages-menus-add',
    component: () => import('@/views/pages/menu/MenuAdd.vue'),
    meta: {
      resource: 'menu',
      action: 'create',
    },
  },
  {
    path: '/menus/edit/:id',
    name: 'pages-menus-edit',
    component: () => import('@/views/pages/menu/MenuEdit.vue'),
    meta: {
      resource: 'menu',
      action: 'update',
    },
  },
]
